import React from 'react';
import Select from '../ui/Select';

const fieldLabel = 'block text-xs font-semibold text-gray-700 dark:text-gray-300 text-left mb-1.5';

/**
 * Generic labeled multi-select for a GPS data filter, driven by a config entry
 * from gpsFilters.config.js. Keeps every filter visually and behaviorally
 * identical wherever it renders (base row or advanced panel).
 */
const GPSFilterSelect = ({ def, gps }) => {
  const options = gps[def.optionsKey] || [];
  return (
    <div>
      <label className={fieldLabel}>
        {def.label} {options.length !== 0 ? `(${options.length})` : ''}
      </label>
      <Select
        isMulti
        enableSelectAll={!!def.enableSelectAll}
        isClearable
        isSearchable
        value={gps[def.valueKey] || []}
        onChange={gps[def.setterKey]}
        options={options}
        getOptionLabel={def.optionLabel}
        placeholder={def.placeholder}
        classNamePrefix="react-select"
        menuPortalTarget={document.body}
      />
    </div>
  );
};

export default GPSFilterSelect;
